export default __webpack_public_path__ + "locales/uk-UA/SendInviteDialog.json?hash=13fb05ec874cd028f23024da6e6882d6";